export default __webpack_public_path__ + "static/media/1.503400c0.svg";